import React, { useContext } from 'react'
import Modal from 'modules/react/signup/Modal'
import SignupContext from 'modules/react/signup/SignupContext'
import SignupContent from 'modules/react/signup/SingleClassOrGSK/SignupContent'

export default function SignupModal () {
  const signupContext = useContext(SignupContext)

  const { cleanUp, setModal, buttonText } = signupContext

  const modalRef = React.createRef()

  React.useEffect(() => {
    setModal(modalRef?.current)
  }, [modalRef?.current])

  return (
    <>
      <button className="button button--full-width" onClick={() => modalRef.current.open()}>{buttonText ? buttonText : 'Tilmeld'}</button>
      <Modal ref={modalRef} onCloseCallback={cleanUp}>
        <SignupContent/>
      </Modal>
    </>
  )
}